<template>

    <div class="container">

        <div id="messages"></div>

        <div class="checklist-header">
            <h1>
                <i @click="reloadPrinters()" class="fas fa-check-square"></i>
                Production Checklist
                <span class="h4 checklist-subtitle">
                    <span :class="{ subtitleCurrentWeek: week.isCurrentWeek }">Week {{ week.num }}</span>,
                    <span v-if="week.isCurrentWeek">commenced</span>
                    <span v-else>commencing</span>
                    {{ week.start }}
                </span>
            </h1>
            <div class="checklist-week-nav">
                <button class="btn btn-default" @click="weekNavBack()" title="Previous Week"><i class="fas fa-arrow-alt-left"></i></button>
                <button class="btn btn-default"  @click="weekNavForward()" title="Next Week"><i class="fas fa-arrow-alt-right"></i></button>
            </div>
        </div>


        <div class="ps-filter-row row-filter">

            <div :class="['ps-filter-col', 'col-filter', 'col-filter-active', {'col-filter-highlight': workcentre_id}]">
                <v-select
                    :options="workcentres_select"
                    :reduce="wc => wc.id"
                    label="name"
                    v-model="workcentre_id"
                    :disabled="loading"
                    placeholder="Workcentre"
                    :searchable="false"
                    :clearable="true"
                    class="tt-filter"
                    @input="selectWorkcentre"
                ></v-select>
            </div>

            <div :class="['ps-filter-col', 'col-filter', 'col-filter-active', {'col-filter-highlight': user_id}]">
                <v-select
                    :options="users_select"
                    :reduce="user => user.id"
                    label="name"
                    v-model="user_id"
                    :disabled="loading"
                    placeholder="Person"
                    :searchable="false"
                    :clearable="true"
                    class="tt-filter"
                    @input="selectUser"
                ></v-select>
            </div>

        </div>

        <div :class="['items']">
            <item v-for="(item, index) in items"
                  :item="item"
                  :index="index"
                  :expanded_by_default="itemIsExpanded(item.id)"
                  @item_expanded="updatedExpandedItem"
                  @items_updated="syncItemsFromStore"
                  :workcentre_filter_ids="workcentre_filter_ids"
                  :workcentre_id="workcentre_id"
                  :user_id="user_id"
                  :auth_user="auth_user"
                  :users_select="users_select"
                  :printers="printers"
                  :key="(itemIsExpanded(item.id) ? 'expanded' : '') + last_loaded + item.id">
            </item>
        </div>

    </div>

</template>

<script>

    import miniToastr from "mini-toastr";
    import vSelect from "vue-select";
    import 'vue-select/dist/vue-select.css';
    import Item from "../production_checklist/Item";
    import api from "../../api";
    import {default as _} from "lodash";

    let Vue = window.Vue;

    export default {

        props: {
            week_prop: {
                type: Object,
                required: true,
            },
            users_select: {
                type: Array,
                required: true
            },
            workcentres_select: {
                type: Array,
                required: true
            },
            workcentre_filter_ids_prop: {
                type: Array,
                required: true
            },
            auth_user: {
                type: Object,
                required: true
            },
            printers_prop: {
                required: true
            },
        },

        data: () => ({
            app_url: window.location.protocol + "//" + window.location.host,
            week: {},
            loading: false,
            last_loaded: Date.now(),
            expanded_items: [],
            users: [],
            items: [],
            user_id: null,
            workcentre_id: null,
            changing_selects: false,
            workcentre_filter_ids: [],
            printers: {},
        }),

        components: {
            miniToastr,
            Item,
            vSelect,
        },

        async created() {
            await this.setFilters();
            await this.loadItems();

            setInterval(this.reloadPrinters, 600*1000);

            window.Echo.channel('checklist')
                .listen('ChecklistCreated', e => {
                    console.log('Broadcast: ChecklistCreated: loadTable()');
                    this.loadItems();
                })
                .listen('ChecklistUpdated', e => {
                    console.log('Broadcast: ChecklistUpdated: loadTable()');
                    this.loadItems();
                })
                .listen('ChecklistDeleted', e => {
                    console.log('Broadcast: ChecklistDeleted: loadTable()');
                    this.loadItems();
                });
        },

        mounted() {
            this.week = JSON.parse(JSON.stringify(this.week_prop));
            this.workcentre_filter_ids = JSON.parse(JSON.stringify(this.workcentre_filter_ids_prop));
            this.printers = JSON.parse(JSON.stringify(this.printers_prop));

            miniToastr.init({
                timeout: 3000,
                appendTarget: document.getElementById('messages'),
            });
        },

        destroyed() {
            window.Echo.leaveChannel('checklist');
        },

        methods: {
            reloadPrinters() {
                return window.axios.get(`/printers`, {
                    params: { format: 'json', filter: 'connected' }
                }).then((response) => {
                    this.printers = response.data;
                });
            },
            getUrlParams() {
                let params = {},
                    sPageURL = window.location.search.substring(1),
                    sURLVariables = sPageURL.split('&'),
                    sParameterName,
                    i;

                for (i = 0; i < sURLVariables.length; i++) {
                    sParameterName = sURLVariables[i].split('=');
                    if (typeof sParameterName[0] !== "undefined" && sParameterName[0].length)
                        params[sParameterName[0]] = decodeURIComponent(sParameterName[1]);
                }

                return params;
            },
            getFilters() {
                return {
                    user_id: this.user_id,
                    workcentre_id: this.workcentre_id,
                };
            },
            clearFilters() {
                this.user_id = null;
                this.workcentre_id = null;
            },
            setFilters() {
                let filters = this.getUrlParams();

                if (typeof filters.user_id !== "undefined") {
                    let user_id_int = parseInt(filters.user_id);
                    this.user_id = user_id_int === 0 ? null : user_id_int;
                }

                if (typeof filters.workcentre_id !== "undefined")
                    this.workcentre_id = parseInt(filters.workcentre_id);

                this.updateUrl();
            },
            updateUrl() {
                history.replaceState(null, "", this.url);
            },
            selectWorkcentre() {
                if (this.loading || this.changing_selects)
                    return;

                this.changing_selects = true;
                this.user_id = null;
                this.changing_selects = false;

                this.loadItems();
            },
            selectUser() {
                if (this.loading || this.changing_selects)
                    return;

                this.changing_selects = true;
                this.workcentre_id = null;
                this.changing_selects = false;

                this.loadItems();
            },
            toTitleCase(str) {
                return Vue.filter('title_case')(str);
            },
            syncItemsFromStore() {
                this.items = JSON.parse(JSON.stringify(this.$store.items));
            },
            updatedExpandedItem(data) {
                let inArray = _.indexOf(this.expanded_items, data.id) !== -1;

                if (data.expanded && ! inArray)
                    this.expanded_items.push(data.id);

                else if (!data.expanded && inArray) {
                    this.expanded_items = _.filter(this.expanded_items, function (item_id) {
                        return item_id !== data.id;
                    });
                }
            },
            weekNav(direction) {
                // Use actual date arithmetic to handle ISO week boundaries correctly
                var d = new Date(Date.UTC(this.week.year, 0, 4)); // Jan 4 is always in week 1
                d.setUTCDate(d.getUTCDate() + (this.week.num - 1) * 7 + (direction * 7));
                // Get ISO week number and year from the resulting date
                var jan4 = new Date(Date.UTC(d.getUTCFullYear(), 0, 4));
                var dayOfYear = Math.round((d - new Date(Date.UTC(d.getUTCFullYear(), 0, 1))) / 86400000) + 1;
                var weekDay = (d.getUTCDay() + 6) % 7; // Monday=0
                this.week.num = Math.ceil((dayOfYear - weekDay + 9) / 7);
                // ISO year: if week >= 52 and month is Jan, it belongs to previous year
                if (this.week.num >= 52 && d.getUTCMonth() === 0) this.week.year = d.getUTCFullYear() - 1;
                else if (this.week.num === 1 && d.getUTCMonth() === 11) this.week.year = d.getUTCFullYear() + 1;
                else this.week.year = d.getUTCFullYear();
                this.loadItems();
            },
            weekNavBack() {
                this.weekNav(-1);
            },
            weekNavForward() {
                this.weekNav(1);
            },
            loadItems() {
                this.loading = true;
                return api.getChecklistItems(this.week.year, this.week.num, this.workcentre_id, this.user_id).then(data => {
                    this.loading = false;
                    if (api.responseHasErrors(data)) return;
                    this.updateUrl();

                    this.$store.items = data.items;
                    this.items = data.items;

                    this.$store.users = data.users;
                    this.users = data.users;

                    this.$store.workcentre_filter_ids = data.workcentre_filter_ids;
                    this.workcentre_filter_ids = data.workcentre_filter_ids;

                    this.week = data.week;
                    this.last_loaded = Date.now();
                });
            },
            itemIsExpanded(item_id) {
                return this.expanded_items.indexOf(item_id) !== -1;
            },
        },

        computed: {
            url() {
                let url = `${this.app_url}/checklist/${this.week.year}/${this.week.num}?`;

                if (this.user_id)
                    url += `user_id=${this.user_id}&`;

                if (this.workcentre_id)
                    url += `workcentre_id=${this.workcentre_id}&`;

                return url;
            },
        },

    }

</script>

<style>

    .checklist-header h1 .fas {
        margin-right: 15px;
    }
    .checklist-header h1 {
        font-size: 28px;
    }
    @media (min-width: 768px) {
        .checklist-header h1 {
            font-size: 36px;
        }
    }

    .loadingfade { opacity: 0.5; }
    .stat {
        display: inline-block;
        min-width: 28px;
        padding: 3px 5px;
        font-size: 12px;
        font-weight: 400;
        line-height: 1;
        color: #fff;
        text-align: center;
        white-space: nowrap;
        border-radius: 3px;
        margin-right: 10px;
        background-color: #6b6f6b;
        opacity: 0.75;
        flex-shrink: 0;
    }
    @media (min-width: 992px) {
        .stat {
            padding: 5px 7px;
            font-size: 14px;
            font-weight: 600;
            margin-right: 20px;
        }
    }
    .small-stat {
        background-color: #979797;
        padding: 3px 5px;
        font-size: 12px;
        font-weight: 600;
    }
    .stat-name {
        background-color: #fff;
        padding: 3px 5px;
        font-size: 11px;
        font-weight: 400;
        color: #313131;
        border: 1px solid #a8a8a8;
    }
    .stat a, .stat a:visited {
        color: #fff;
    }
    .checklist-header {
        display: flex;
        margin: 10px 0 10px 0;
        justify-content: space-between;
        align-items: center;
    }
    .checklist-subtitle {
        display: block;
        padding: 15px 0 0 25px;
        color: #666;
        margin: 0 24px;
        font-size: 15px;
    }
    @media (min-width: 768px) {
        .checklist-subtitle {
            font-size: 18px;
            padding: 15px 0 0 34px;
        }
    }
    .subtitleCurrentWeek {
        border-bottom: 2px solid #428c38;
        color: #14590b;
    }
    .checklist-week-nav {
        display: flex;
        height: 40px;
    }
    .checklist-week-nav button {
        font-size: 18px;
        color: #6c6c6c;
        margin: 0 5px;
    }
    .mini-toastr {
        position: absolute !important;
        right: 0 !important;
        top: 0 !important;
    }
    .mini-toastr-notification__message {
        padding: 0 !important;
    }
    #messages {
        position: relative;
    }
    .mini-toastr__notification.-success {
        background-color: #15831a !important;
    }


    .ps-filter-row {
        display: flex;
        align-items: center;
        flex-direction: row;
        justify-content: flex-end;
    }
    .ps-filter-col {
        flex-grow: 1;
        max-width: 20%;
        margin-left: 40px;
    }
    .ps-filter-col-btn {
        flex-grow: 0;
        max-width: 20%;
    }


    .tt-filter-active {}

    .tt-filter .vs__selected {
        white-space: nowrap;
    }
    .tt-filter .vs__selected-options {
        overflow: hidden;
        flex-wrap: nowrap;
    }
    .tt-filter .vs__state-active-bg {
        overflow: hidden;
    }


    .row-filter {
        margin-bottom: 20px;
    }
    .col-filter {
        margin-top: 15px;
        border: 2px solid #fff;
        border-radius: 5px;
    }
    @media (min-width:992px) {
        .col-filter {
            margin-top: 0;
        }
    }

    .col-filter-label {
        font-size: 18px;
        margin: 0 0 8px 0;
        color: #505050;
    }
    .col-filter-badge {
        margin: 0 0 0 10px;
        background-color: #bfbfbf;
        color: #fff;
        border-radius: 4px;
        display: inline-block;
        font-size: 12px;
        vertical-align: top;
    }

    .col-filter-active .vs__dropdown-toggle {
        border: 1px solid #9ea193;
    }
    .col-filter-active .col-filter-label {
        font-weight: bold;
        color: #3f3f3f;
    }

    .col-filter-highlight {
        border: 2px solid #808080;
    }


    .nopoint {
        pointer-events: none;
    }
    .large-status {
    }
    .large-status .vs__open-indicator,
    .large-status .vs__actions,
    .large-status .vs__search {

    }
    .large-status .vs__search {
        padding: 0;
    }
    .large-status .vs__dropdown-toggle {
        border: none;
    }
    .large-status.vs--single.vs--open .vs__selected {
        position: relative;
    }
    .large-status .vs__dropdown-option--selected,
    .large-status .vs__dropdown-option,
    .large-status .vs__dropdown-option--highlight,
    .large-status .vs__dropdown-option--selected:hover,
    .large-status .vs__dropdown-option:hover,
    .large-status .vs__dropdown-option--highlight:hover {
        background-color: #fff;
    }

    .large-status.vs--disabled .vs__clear, .large-status.vs--disabled .vs__dropdown-toggle,
    .large-status.vs--disabled .vs__open-indicator, .large-status.vs--disabled .vs__search,
    .large-status.vs--disabled .vs__selected {
        background-color: #fff;
        opacity: 0.9;
    }
    .btn.disabled, .btn[disabled], fieldset[disabled] .btn {
        filter: alpha(opacity=90) !important;
        opacity: .9 !important;
    }


    .vs__dropdown-option {
        padding: 6px 20px;
        font-size: 18px;
    }

    .vs__clear {
        fill: rgba(95, 95, 95, 0.5);
        padding: 0;
        border: 1px solid #e0e0e0;
        background-color: #e7e7e7;
        cursor: pointer;
        margin: 0 4px 0 0;
        width: 25px;
        height: 25px;
        border-radius: 20px;
    }
    @media (min-width: 1200px) {
        .vs__clear {
            margin: 0 12px 0 0;
        }
    }


    .btn-large-status {
        color: #fff;
        font-size: 35px;
        padding: 6px 16px;
        margin: 0 10px 0 0;
    }
    .btn-large-status .fa {
        color: #fff;
    }
    .btn-large-status:hover, .btn-large-status:active .btn-large-status:focus {
        color: #fff;
    }
    .large-status-badge {
        font-size: 15px;
        padding: 5px 10px;
    }
    @media (min-width: 1200px) {
        .large-status-badge {
            font-size: 18px;
        }
    }

</style>